(function() {
	'use strict';
	
	angular.module('app.core').filter('relativeTime', function() {
		return function(input) {
			var m = moment(input);
			return m.fromNow();
		};
	});
	angular.module('app.core').filter('relativeDate', function() {
		return function(input) {
			var m = moment.utc(input).startOf('day');
			var today = moment.utc().startOf('day');
			var diff = today.diff(m, 'days');
			switch(diff) {
			case 0: return 'today';
			case -1: return 'tomorrow';
			case 1: return 'yesterday';

			default:
				return m.from(today);
			}
		};
	});
})();;